(function () {
  "use strict";
  var doc = document;
  var root = doc.documentElement;
  var SHOW_PAST = 140;
  var HIDE_UNDER = 40;
  var STATE = "data-xg-state";
  var READY = "data-xg-chrome-ready";
  var accountOpen = false;
  function chrome() {
    return doc.querySelector("[data-xg-chrome]");
  }
  function setVar(name, value) {
    if (root.style.getPropertyValue(name) !== value) {
      root.style.setProperty(name, value);
    }
  }
  function apply() {
    var el = chrome();
    if (!el) return;
    var full = el.offsetHeight;
    if (!full) return;
    setVar("--xg-header-h", full + "px");
  }
  function place() {
    var main = doc.getElementById("xg-main");
    if (!main) return;
    var bars = doc.querySelectorAll("[data-xg-announce]");
    var fresh = null;
    var placed = null;
    for (var i = 0; i < bars.length; i += 1) {
      if (main.contains(bars[i])) placed = bars[i];
      else fresh = bars[i];
    }
    if (!fresh) {
      if (placed && !chrome()) placed.remove();
      return;
    }
    if (placed) placed.remove();
    var first = main.firstElementChild;
    if (!first) return;
    first.insertAdjacentElement("afterend", fresh);
    fresh.setAttribute("data-xg-placed", "");
  }
  function onScroll() {
    var el = chrome();
    if (!el) return;
    var y = window.scrollY;
    var top = el.getAttribute(STATE) === "top";
    if (top && y > SHOW_PAST) el.removeAttribute(STATE);
    else if (!top && y < HIDE_UNDER) el.setAttribute(STATE, "top");
  }
  var scheduled = false;
  window.addEventListener(
    "scroll",
    function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        onScroll();
        if (accountOpen) closeAccount(null);
      });
    },
    { passive: true }
  );
  function panelOf(toggle) {
    var wrap = toggle && toggle.closest ? toggle.closest("[data-xg-account]") : null;
    return wrap ? wrap.querySelector("[data-xg-account-menu]") : null;
  }
  function enhance() {
    var toggles = doc.querySelectorAll("[data-xg-account-toggle]");
    for (var i = 0; i < toggles.length; i += 1) {
      var panel = panelOf(toggles[i]);
      if (!panel || !panel.id) continue;
      panel.removeAttribute("hidden");
      toggles[i].setAttribute("aria-controls", panel.id);
      toggles[i].setAttribute("aria-haspopup", "true");
      if (!toggles[i].hasAttribute("aria-expanded")) {
        toggles[i].setAttribute("aria-expanded", "false");
      }
    }
  }
  function closeAccount(except) {
    var toggles = doc.querySelectorAll("[data-xg-account-toggle]");
    for (var i = 0; i < toggles.length; i += 1) {
      var panel = panelOf(toggles[i]);
      if (!panel || panel === except) continue;
      toggles[i].setAttribute("aria-expanded", "false");
      panel.removeAttribute(STATE);
    }
    accountOpen = except !== null && except !== undefined;
  }
  function openAccount(toggle) {
    var panel = panelOf(toggle);
    if (!panel) return;
    closeAccount(panel);
    toggle.setAttribute("aria-expanded", "true");
    panel.setAttribute(STATE, "open");
    accountOpen = true;
  }
  function openToggle() {
    var toggles = doc.querySelectorAll("[data-xg-account-toggle]");
    for (var i = 0; i < toggles.length; i += 1) {
      if (toggles[i].getAttribute("aria-expanded") === "true") return toggles[i];
    }
    return null;
  }
  function firstItem(panel) {
    return panel.querySelector("a[href], button:not([disabled])");
  }
  doc.addEventListener("click", function (event) {
    if (!event.target || !event.target.closest) return;
    var toggle = event.target.closest("[data-xg-account-toggle]");
    if (toggle) {
      if (!toggle.hasAttribute("aria-expanded") || !panelOf(toggle)) return;
      event.preventDefault();
      if (toggle.getAttribute("aria-expanded") === "true") closeAccount(null);
      else openAccount(toggle);
      return;
    }
    if (event.target.closest("[data-xg-account-menu]")) return;
    closeAccount(null);
  });
  doc.addEventListener("keydown", function (event) {
    if (!event.target || !event.target.closest) return;
    if (event.key === "Escape") {
      var open = openToggle();
      if (!open) return;
      event.preventDefault();
      closeAccount(null);
      open.focus();
      return;
    }
    if (event.key !== "ArrowDown") return;
    var toggle = event.target.closest("[data-xg-account-toggle]");
    if (!toggle || !toggle.hasAttribute("aria-expanded")) return;
    var panel = panelOf(toggle);
    if (!panel) return;
    event.preventDefault();
    openAccount(toggle);
    var item = firstItem(panel);
    if (item) item.focus();
  });
  doc.addEventListener("focusout", function (event) {
    var wrap = event.target && event.target.closest
      ? event.target.closest("[data-xg-account]")
      : null;
    if (!wrap) return;
    var next = event.relatedTarget;
    if (!next || wrap.contains(next)) return;
    closeAccount(null);
  });
  var observed = new WeakSet();
  var sizeObserver = null;
  function watch() {
    var el = chrome();
    if (!el || !("ResizeObserver" in window) || observed.has(el)) return;
    if (sizeObserver) sizeObserver.disconnect();
    sizeObserver = new ResizeObserver(apply);
    sizeObserver.observe(el);
    observed.add(el);
  }
  function init() {
    enhance();
    closeAccount(null);
    place();
    apply();
    onScroll();
    watch();
    root.setAttribute(READY, "");
  }
  if (doc.readyState === "loading") {
    doc.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  var resizeQueued = false;
  window.addEventListener(
    "resize",
    function () {
      if (resizeQueued) return;
      resizeQueued = true;
      requestAnimationFrame(function () {
        resizeQueued = false;
        apply();
      });
    },
    { passive: true }
  );
  doc.addEventListener("shopify:section:load", init);
  doc.addEventListener("shopify:section:unload", init);
  window.XG = window.XG || {};
  window.XG.header = { sync: apply, closeAccount: closeAccount };
})();
